import React from "react";
export var FilterAlleyTab;
(function (FilterAlleyTab) {
    FilterAlleyTab[FilterAlleyTab["Filters"] = 0] = "Filters";
    FilterAlleyTab[FilterAlleyTab["LocationFilters"] = 1] = "LocationFilters";
})(FilterAlleyTab || (FilterAlleyTab = {}));
export var AdvancedAlleyContext = React.createContext({});
export var AdvancedAlleyContextProvider = function (_a) {
    var value = _a.value, children = _a.children;
    return (React.createElement(AdvancedAlleyContext.Provider, { value: value }, children));
};
//# sourceMappingURL=advanced-alley-context.js.map